// Angular
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// Rxjs
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

// Service
import { TokenStorageService } from '../../../app/state/core/services/token-storage/token-storage.service';
import { GlobalStoreService } from '../../../app/state/global/global-store.service';
import { AuthStoreService } from '../../../app/state/modules/auth/auth-store.service';

// Constant
import { ROUTE_CONSTANTS } from '../../../app/constants/route';
import { LocalStorageUtil } from '../utils/local-storage-util';
import { Role } from '../../constants/enum/common/role-enum';
import { Billing } from '../../constants/enum/common/Billing-tabs.enum';
import { BillingErrors } from '../../constants/enum/billing-errors.enum';
import { ToasterService } from '../services/toaster.service';

/**
 * This component used to navigate to login if the request is unauthorized
 *
 * @author Vikas thakkar <vikasthakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 29/04/2020 (Vikas thakkar <vikasthakkar@saeculumsolutions.com>) AuthInterceptor created
 */
@Injectable({
  providedIn: 'root',
})

export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router,
    private tokenStorageService: TokenStorageService,
    private authStoreService: AuthStoreService,
    private toasterService: ToasterService,

  ) {
  }

  /**
   * Intercepts the response and navigate to login if the accesstoken is not valid
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error, caught) => {
        this.handleAuthError(error);
        if (error.status === 401) {
          return of([]);
        }
        return of(error);
      }) as any,
      finalize(() => true),
    );
  }


  private handleAuthError(err: any): Observable<any> {
    if (err.status === 401) {
      this.tokenStorageService.clear();
      this.authStoreService.dispatchClearReducer({});
      this.router.navigate([ROUTE_CONSTANTS.CONTAINER.AUTH, ROUTE_CONSTANTS.AUTH.LOGIN]);
    } else if (err.status === 402) {
      this.tokenStorageService.clearBusinessToken();
      this.authStoreService.dispatchClearBusinessReducer({});
      if (LocalStorageUtil.getExactUserRole()) {
        if (LocalStorageUtil.getExactUserRole() === Role.System_Administrator) {
          if (err && err.error && err.error.code && (err.error.code === BillingErrors.PAYMENT_FAILED || err.error.code === BillingErrors.PLAN_CANCELED || err.error.code === BillingErrors.TRIAL_ACTIVE || err.error.code === BillingErrors.TRIAL_EXPIRED)) {
            this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.SETTING_ONLY, err.error.business_guid], { queryParams: { activeTab: Billing.Plan } });

            let message = '';
            switch (err.error.code) {
              case BillingErrors.PAYMENT_FAILED:
                message = 'Payment Failed'
                break;
              case BillingErrors.PLAN_CANCELED:
                message = 'Plan Cancelled'
                break;
              case BillingErrors.TRIAL_EXPIRED:
                message = 'Trial Expired'
                break;
              default:
                break;
            }
            if (message) {
              this.toasterService.errorShow(message, '', { closeButton: true, timeOut: 3000 });
            }

          } else {
            this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.CHANGE_BUSINESS]);
          }
        } else {
          this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.CONTAINER.ERROR, 402]);
        }
      } else {
        this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.CHANGE_BUSINESS]);
      }
    } else if (err.status === 403) {
      this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.CHANGE_BUSINESS]);
    }
    throw err;
  }
}

